<template>
  <div>
    <div id="appointment-details" :class="isRTL ? 'rtl' : 'normal'">
      <div v-if="showBarcode">
        <p>
          <span
            ><strong> {{ siteText.ui.barcodeforCheckin }} </strong></span
          >
          <v-flex>
            <img alt="Bar code" :id="'BC' + booking.ConfirmationNumber" />
          </v-flex>
        </p>
      </div>
      <p>
        {{ booking.FirstName }} {{ booking.LastName }}<br />
        <span v-if="booking.CellPhone">{{ booking.CellPhone }}<br /></span>
        <span v-if="booking.Email">{{ booking.Email }}</span>
      </p>
      <p>
        <span
          ><strong> {{ siteText.ui.viewConfirmationNumber }} </strong></span
        >
        {{ booking.ConfirmationNumber }}
      </p>
      <p>
        <span
          ><strong> {{ siteText.ui.selectedService }}: </strong></span
        >
        {{ serviceType1Details.Name }} <br />
        <span
          v-if="showServiceTypeLink && serviceType1Details.AdditionalInfoText"
        >
          {{ serviceType1Details.AdditionalInfoText }}
        </span>
        <a
          v-if="showServiceTypeLink"
          target="_blank"
          :href="serviceType1Details.Url"
          >{{ serviceType1Details.UrlText }}</a
        >
      </p>
      <p v-if="booking.ServiceTypeId2">
        <span
          ><strong> {{ siteText.ui.selectedService }}: </strong></span
        >
        {{ serviceType2Details.Name }} <br />
        <span v-if="serviceType2Details.AdditionalInfoText"
          >{{ serviceType2Details.AdditionalInfoText }}
        </span>
        <a
          v-if="showServiceTypeLink"
          target="_blank"
          :href="serviceType2Details.Url"
          >{{ serviceType2Details.UrlText }}</a
        >
      </p>
      <div>
        <strong> {{ siteText.ui.location }}: </strong> {{ booking.SiteName }},
        {{ booking.SiteAddress }} <br />
        <a v-if="showMapLink" target="_blank" :href="booking.MapUrl">{{
          siteText.ui.viewMapLinkText
        }}</a>
        <br />
        <strong> {{ siteText.ui.date }}: </strong> {{ appointmentDate }} <br />
        <strong> {{ siteText.ui.time }}: </strong><span class="ltr-text-force">{{ booking.FormattedBookingTime }}</span>
      </div>
      <p class="noPrint">
        <a
          v-if="showPrintLink"
          href="#"
          class="text-decoration-underline"
          @click="Printer()"
        >
          {{ siteText.ui.viewPdfLinkText }}
        </a>
      </p>
      <p>{{ footerText }}</p>
      <p>{{ footerText2 }}</p>
    </div>
    <div :hidden="true" id="appointment-details-hidden">
      <div
        style="
          font-family: sans-serif;
          border: 1px black solid;
          padding: 10px;
          max-width: 600px;
        "
        id="appointment-details-print"
      >
        <div style="margin-left: -170px; margin-bottom: 15px">
          <img src="../assets/NYDMVLogoBW.png" />
        </div>
        <h2 style="margin-bottom: 15px">Reservation Confirmed</h2>
        <div style="margin-bottom: 15px" v-if="showBarcode">
          <p>
            <span
              ><strong> {{ siteText.ui.barcodeforCheckin }} </strong></span
            >
            <v-flex>
              <img alt="Bar code" :id="'BCP' + booking.ConfirmationNumber" />
            </v-flex>
          </p>
        </div>
        <p style="margin-bottom: 20px">
          {{ booking.FirstName }} {{ booking.LastName }}<br />
          <span v-if="booking.CellPhone">{{ booking.CellPhone }}<br /></span>
          <span v-if="booking.Email">{{ booking.Email }}</span>
        </p>
        <p style="margin-bottom: 20px">
          <span
            ><strong> {{ siteText.ui.viewConfirmationNumber }} </strong></span
          >
          {{ booking.ConfirmationNumber }}
        </p>
        <p style="margin-bottom: 20px">
          <span
            ><strong> {{ siteText.ui.selectedService }}: </strong></span
          >
          {{ serviceType1Details.Name }} <br />
          <span
            v-if="showServiceTypeLink && serviceType1Details.AdditionalInfoText"
          >
            {{ serviceType1Details.AdditionalInfoText }}
          </span>
        </p>
        <div style="margin-bottom: 20px" v-if="booking.ServiceTypeId2">
          <p>
            <span
              ><strong> {{ siteText.ui.selectedService }}: </strong></span
            >
            {{ serviceType2Details.Name }} <br />
            <span v-if="serviceType2Details.AdditionalInfoText"
              >{{ serviceType2Details.AdditionalInfoText }}
            </span>
          </p>
        </div>
        <p style="margin-bottom: 20px">
          <span
            ><strong> {{ siteText.ui.location }}: </strong>
            {{ booking.SiteName }}, {{ booking.SiteAddress }}</span
          >
        </p>
        <p>
          <strong> {{ siteText.ui.date }}: </strong> {{ appointmentDate }}
          <br />
          <strong> {{ siteText.ui.time }}: </strong>
          {{ booking.FormattedBookingTime }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import jsbarcode from "jsbarcode";
//import Print from '../Utilities/Print';
import { jsPDF } from "jspdf";

export default {
  data: () => ({
    confirmationNumber: 1234567890,
  }),
  props: {
    booking: {},
    showBarcode: Boolean,
    footerText: String,
    footerText2: String,
    showMapLink: Boolean,
    showServiceTypeLink: Boolean,
    showPrintLink: Boolean,
    isRTL: Boolean,
  },
  methods: {
    Printer() {
      // console.log('Inside Printer of ReservationDetails');
      // Print.Print('appointment-details');

      const doc = new jsPDF();
      const html = document.querySelector("#appointment-details-print");
      const _this = this;
      doc.html(html, {
        callback: function (doc) {
          doc.save(`reservation_${_this.booking.ConfirmationNumber}.pdf`);
        },
        x: 15,
        y: 15,
        width: 170, //target width in the PDF document
        windowWidth: 650, //window width in CSS pixels
      });
    },
  },
  computed: {
    ...mapGetters(["siteText"]),
    ...mapGetters(["language"]),
    ...mapGetters(["isRTLLanguage"]),
    appointmentDate() {
      const bookingDate = new Date(this.booking.BookingDateTime);
      const month = bookingDate.toLocaleString(this.language, {
        month: "long",
      });
      const day = bookingDate.getDate();
      const year = bookingDate.getFullYear();
      return `${month} ${day}, ${year}`;
    },
    serviceType1Details() {
      let serviceType = null;
      if (this.booking.ServiceTypeId) {
        serviceType = this.$store.getters.serviceType(
          this.booking.ServiceTypeId
        );
      }
      return serviceType;
    },
    serviceType2Details() {
      let serviceType = null;
      if (this.booking.ServiceTypeId2) {
        serviceType = this.$store.getters.serviceType(
          this.booking.ServiceTypeId2
        );
      }
      return serviceType;
    },
  },
  mounted() {
    // finished rendering to the DOM
    this.confirmationNumber = this.booking.ConfirmationNumber;
    if (this.confirmationNumber && this.showBarcode) {
      // eslint-disable-next-line
      jsbarcode(`#BC${this.confirmationNumber}`, this.confirmationNumber, {
        format: "code39",
        lineColor: "#000000",
        background: "#FFFFFF",
        width: 1.25,
        height: 35,
        displayValue: false,
      });

      //generate the barcode again for printable version//
      jsbarcode(`#BCP${this.confirmationNumber}`, this.confirmationNumber, {
        format: "code39",
        lineColor: "#000000",
        background: "#FFFFFF",
        width: 1.25,
        height: 35,
        displayValue: false,
      });
    }
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
